import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'react-fa'

import './RemoveButton.scss'

const RemoveButton = props => {
  const { title, onClick, className } = props
  const buttonClasses = `${className} remove-button`
  return (
    <div className={buttonClasses} title={title} >
      <Icon className='remove-button__icon' name='remove' onClick={onClick} />
    </div>
  )
}

RemoveButton.defaultProps = {
  className: ''
}

RemoveButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string
}

export default RemoveButton



// WEBPACK FOOTER //
// ./src/components/RemoveButton/RemoveButton.js